import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';

import BreadcrumbMenu from '../../../components/menus/teambcmenu';
import Layout from '../../../components/layout';
import MemberPage from '../../../components/aboutus/memberpage';
import React from 'react';
import SEO from '../../../components/seo';
import SideNavBar from '../../../components/menus/teamnavbarmenu';
import { graphql } from 'gatsby';

let gmdv = require(`../../../ghc_config`);

const Detail = ({ data, location }) => {

  //  Menu relation
  let menuName = gmdv.getMenuid(`/about-us/company-profile/leadership-team`)

  //  Page
  const page = data.nodeLeadershipTeam
  const member = data.allParagraphLeadershipTeam.edges[0].node
  let dirImage = '/images/avatars/noimage.png'
  if (member.relationships.field_member_photo != null) {
    dirImage = member.relationships.field_member_photo.localFile.childImageSharp.member_photo.src
  }

  let backgroundImage = ''
  if (page.relationships.field_image_banner != null) {
    backgroundImage = page.relationships.field_image_banner.localFile.childImageSharp.leadershipteam.src
    backgroundImage = encodeURI(backgroundImage)
  }

  return (
    <Layout>
      <SEO 
        title={`${page.title} - ${member.field_title}`}
        description={`Genesis HealthCare offers long term care services, short stay care, transitional care services, rehab services and specialty services`}
        keywords={[`Long Term Care Services`, `Transitional Care`, `Transitional Care Services`, `Genesis Rehab`]} 
      />
      <main>
        <MDBContainer tag="section" id="maincontent">
          <MDBRow center>
            <MDBCol xs="12" md="3" lg="3" className="col-12 leftside">
              <SideNavBar menuName={menuName} location={location}/>
            </MDBCol>
            <MDBCol xs="12" md="9" lg="9" className="col-12 contentRight">
              <h1 className="pagetitle" 
                style={{backgroundImage: `url(${backgroundImage})`}}>
                {page.title}
              </h1>
              <BreadcrumbMenu title={member.field_title}/>
              <MDBRow center>
                <MemberPage
                  title={member.field_title}
                  alias={member.field_sortalias}
                  sub_title={member.field_sub_title}
                  description={member.field_description}
                  image={dirImage}
                />
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </main>
    </Layout>
  )
}

export default Detail;

export const query = graphql`
query ($id: String!) {
  # Leadership Team Home 
  nodeLeadershipTeam(id: {eq: "23dacdc0-dcc2-58b7-8378-b3d195b7b529"}) {
    id
    title
    path {
      alias
    }
    relationships {
      field_image_banner {
        localFile {
          childImageSharp {
            leadershipteam: original {
              src
            }
          }
        }
      }
    }
  }
  # Directors
  allParagraphLeadershipTeam(filter: {
    id: {eq: $id},
    relationships: {node__leadership_team: {elemMatch: {id: {eq: "23dacdc0-dcc2-58b7-8378-b3d195b7b529"}}}}}) 
  {
    edges {
      node {
        id
        field_title
        field_sub_title
        field_sortalias
        field_description {
          value
        }
        relationships {
          field_member_photo {
            localFile {
              childImageSharp {
                member_photo: resize(width: 132, height: 190) {
                  src
                }
              }
            }
          }
        }
      }
    }
  }

  # Menu relation
  allMenuLinkContentMenuLinkContent {
    edges {
      node {
        title
        link {
          uri
        }
        menu_name
      }
    }
  }
}
`